<template>
    <div class="not-found">
        <h1>404</h1>
        <p>抱歉,您访问的页面不存在。</p>
        <router-link to="/">返回首页</router-link>
    </div>
</template>

<script>
export default {
    name: "NotFound",
};
</script>

<style scoped>
.not-found {
    text-align: center;
    padding: 60px 20px;
}
.not-found h1 {
    font-size: 72px;
    margin: 0 0 16px;
    color: #42b983;
}
.not-found p {
    color: #666;
    margin-bottom: 24px;
}
.not-found a {
    color: #42b983;
    text-decoration: none;
    border: 1px solid #42b983;
    padding: 8px 20px;
    border-radius: 4px;
}
.not-found a:hover {
    background: #42b983;
    color: #fff;
}
</style>
